import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { RegistrationFeeSharePayloadType } from "../types/registrationFeeShareRequest";
import {
  RegistrationFeeShareResponseType,
  RegistrationFeeShareApiResponse,
} from "../types/registrationFeeShareResponse";

export const registrationFeeShareApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllRegistrationFeeShares: builder.query<
      RegistrationFeeShareApiResponse,
      {
        size?: number;
        search?: string;
        page?: number;
        session_id?: number;
        course_id?: number;
        type_id?: number;
        share_type?: string;
      }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.session_id)
          queryParams.append("session_id", params.session_id.toString());
        if (params?.course_id)
          queryParams.append("course_id", params.course_id.toString());
        if (params?.type_id)
          queryParams.append("type_id", params.type_id.toString());
        if (params?.share_type)
          queryParams.append("share_type", params.share_type);

        return `registration-fee-share/get-all?${queryParams.toString()}`;
      },
      providesTags: ["RegistrationFeeShare"],
    }),
    addRegistrationFeeShare: builder.mutation<
      ApiResponseType<{ feeShare: RegistrationFeeShareResponseType }>,
      RegistrationFeeSharePayloadType
    >({
      query: (payload) => ({
        url: "registration-fee-share/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFeeShare", "Centers"],
    }),
    getRegistrationFeeShareById: builder.query<
      ApiResponseType<{
        feeShare?: RegistrationFeeShareResponseType;
        registrationfeeshare?: RegistrationFeeShareResponseType;
      }>,
      { id: string }
    >({
      query: ({ id }) => `registration-fee-share/get/${id}`,
      providesTags: ["RegistrationFeeShare"],
    }),
    updateRegistrationFeeShare: builder.mutation<
      ApiResponseType<{ feeShare: RegistrationFeeShareResponseType }>,
      { id: string; payload: RegistrationFeeSharePayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `registration-fee-share/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["RegistrationFeeShare", "Centers"],
    }),
    deleteRegistrationFeeShare: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `registration-fee-share/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RegistrationFeeShare", "Centers"],
    }),
  }),
});

export const {
  useGetAllRegistrationFeeSharesQuery,
  useAddRegistrationFeeShareMutation,
  useGetRegistrationFeeShareByIdQuery,
  useUpdateRegistrationFeeShareMutation,
  useDeleteRegistrationFeeShareMutation,
} = registrationFeeShareApi;
